export const defaultStyle = {
    wrapper: "relative flex items-center",
    label: "absolute left-5 transition-transform transform text-black",
    input: "w-full pt-6 pr-14 pb-2 pl-5 border border-black rounded-[15px] body-m font-bold focus:outline-none",
    icon: "absolute right-5 bg-white",
}
